import api from "@/services/api";

import { SET_PROMO, SET_PROMO_STATUS } from "@/store/mutation-types";

export default {
  async fetch({ commit }) {
    const content = await api.promos.fetch();

    commit(SET_PROMO, content);
    commit(SET_PROMO_STATUS, "loaded");

    return { content };
  }
};
